import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import formatRelativeWithOptions from 'date-fns/esm/fp/formatRelativeWithOptions/index.js';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';

class NewCarDay extends Component {

    state = {
        carId: this.props.car.carId,
        licenseNumber: this.props.car.licenseNumber,
        date: this.props.day,
        driverEmployeeId: this.props.car.defaultDriverEmployeeId,
        comment: '',

        projectId: '',
        locationName: '',
        km: '',
        errors: new Map(),

        selectedEmployee: this.props.carDay?.driverEmployeeId ? { value: this.props.carDay.driverEmployeeId, label: this.props.carDay.driverName }
            : this.props.car.defaultDriverEmployeeId && { value: this.props.car.defaultDriverEmployeeId, label: this.props.car.defaultDriverEmployeeName },
        selectedProject: {},
        newDayLocation: this.props.carDay,
        newDay: this.props.carDay === undefined || this.props.carDay === null,
    }

    componentDidMount() {
        console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        let path;
        let requestObject
        if (this.state.newDayLocation) {
            path = '/api/cardaylocation';
            requestObject = {
                "carDayId": this.props.carDay.privateId,
                "projectId": this.state.selectedProject?.value,
                "locationName": this.state.locationName,
                "km": trimSpaces(this.state.km),
            };
        } else {
            path = '/api/carday';
            requestObject = {
                "carId": this.state.carId,
                "licenseNumber": this.state.licenseNumber,
                "date": toDateFormat(this.state.date),
                "driverEmployeeId": this.state.selectedEmployee ? this.state.selectedEmployee.value : null,
                "comment": this.state.comment,
                "active": true,

                "projectId": this.state.selectedProject?.value,
                "locationName": this.state.locationName,
                "km": trimSpaces(this.state.km)
            };
        }
        console.log(requestObject);
        await handlePost(path, requestObject, this);
    };

    handleRefuelCheckedChange = () => {
        this.setState({ refuelChecked: !this.state.refuelChecked });
    }

    promiseEmployeeOptions = async () => {
        const params = {
            haveDriverLicense: true
        };
        const response = await axios.get('/api/employees', { params })
        return response.data.map(resp => ({
            label: resp.employee.name,
            value: resp.employee.privateId
        }));
    };

    handleEmployeeSelected = (e, v) => {
        console.log(v);
        this.setState({ selectedEmployee: v })
    }

    getDateString = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
    }

    promiseProjectOptions = async () => {
        const fomattedDate = this.getDateString(this.state.date);
        const params = {
            date: fomattedDate
        }
        const response = await axios.get('/api/projects', { params })
        return response.data.map(resp => ({
            label: `${resp.publicId} - ${resp.location}(${resp.customers.map(obj => obj.name).join(', ')})`,
            value: resp.privateId,
            location: resp.location
        }));
    };

    handleProjectSelected = (e, v) => {
        console.log(v);
        this.setState({ selectedProject: v })
    }

    isDriverDisabled = () => {
        return this.props.carDay !== undefined && this.props.carDay?.driverEmployeeId !== undefined;
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="licenseNumber"
                            label="Rendszám"
                            errors={this.state.errors}
                            value={this.state.licenseNumber}
                            disabled
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="date"
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            disabled
                            onChange={v => handleChangeValue(v, "date", this)}
                        />
                    </div>
                    {this.state.newDay && <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            label={'Söfőr'}
                            required={false}
                            disabled={this.isDriverDisabled()}
                        />
                    </div>}
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedProject}
                            defaultvale={this.state.selectedProject}
                            getOptions={this.promiseProjectOptions}
                            onChange={this.handleProjectSelected}
                            label={'Project'}
                            required={false}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="locationName"
                            label="Egyéb helyszín"
                            errors={this.state.errors}
                            value={this.state.locationName}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="km"
                            label="Megtett km"
                            errors={this.state.errors}
                            value={this.state.km}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    {/* <div className='input-group'>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.refuelChecked}
                                    onChange={this.handleRefuelCheckedChange}
                                    color="primary"
                                />}
                            label="Tankolt" />
                    </div>
                    {this.state.refuelChecked ?
                        <>
                            <div className='input-group'>
                                <ErrorAwareAmountField
                                    name="refuelingAmountLiter"
                                    label="Tankolt liter"
                                    errors={this.state.errors}
                                    value={this.state.refuelingAmountLiter}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group'>
                                <ErrorAwareAmountField
                                    name="refuelingAmountForint"
                                    label="Tankolt összeg"
                                    errors={this.state.errors}
                                    value={this.state.refuelingAmountForint}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group'>
                                <ErrorAwareTextField
                                    name="refuelingBillId"
                                    label="Számla száma"
                                    errors={this.state.errors}
                                    value={this.state.refuelingBillId}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                        </>
                        : <></>} */}
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewCarDay);
